// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"387":"02805236","509":"74993c9f","867":"5072b39c","929":"4dd6d9bf"}[chunkId] + ".chunk.css";
};